import { Product, createProduct, DtoProduct } from '../ecommerce/DtoProduct';
import { DtoTicketCategory } from './DtoTicketCategory';

export interface DtoTicketsAndAddons {
    seatsAvailable: number | null;
    ticketCategories: DtoTicketCategory[];
    products: Product[];
    allItemsAreFree: boolean;
    hasCeus: boolean;
}

export class TicketsAndAddons implements DtoTicketsAndAddons {
    seatsAvailable!: number | null;
    ticketCategories!: DtoTicketCategory[];
    products!: Product[];
    allItemsAreFree!: boolean;
    hasCeus!: boolean;

    constructor(dtoTicketsAndAddons: DtoTicketsAndAddons) {
        Object.assign(this, dtoTicketsAndAddons);
    }

    getAddonName(productId: number) {
        if (this.products) {
            var product = this.products.find(product => product.id == productId);
            if (product != null) {
                return product.name;
            }
        }
        return "";
    }
}

export function createTicketsAndAddons(dtoTicketsAndAddons?: DtoTicketsAndAddons | any) {
    let obj = <DtoTicketsAndAddons>{
        seatsAvailable: 0,
        products: [],
        ticketCategories: [],
        allItemsAreFree: false,
        hasCeus: false
    };

    if (dtoTicketsAndAddons && dtoTicketsAndAddons.products) {
        dtoTicketsAndAddons.products = dtoTicketsAndAddons.products.map((product: DtoProduct) => createProduct(product));
    }

    if (dtoTicketsAndAddons) {
        Object.assign(obj, dtoTicketsAndAddons);
    }

    return new TicketsAndAddons(obj);
}
